import React from 'react';
import {Card, Container} from 'react-bootstrap';
import {Link} from "react-router-dom";
import ArchiveGrid from './ArchiveGrid';



export default function Archive() {
    return (
        
        <div className="container">
            <div >
            <h2 style={{paddingLeft:'10%'}}>Borttagna Leads</h2>
            </div>
           


            <div className="row">
                <div className="col">
                    <Card className="Card">
                        <ArchiveGrid/>
                    </Card>
                </div>
            </div>
        </div>
    )
}
